import Content from "@/views/MGT/Version/Components/Content";
import { versionInfo } from "@/service/version";
export default {
  name: "VersionNoPage",
  components: {
    Content
  },
  data() {
    return {
      list: []
    };
  },
  methods: {
    async getVersion() {
      const params = {
        firstResult: 0,
        pageSize: 3
      };
      let res = await versionInfo(params);
      if (res.data && res.data.result === 0) {
        this.list = res.data.retVal.datas;
      }
    }
  },
  mounted() {
    this.getVersion();
  }
};